define('FileUploadPDP.ei1.Main.View', [
    'file_upload_pdp.tpl',
    'Backbone',
    'Utils',
    'FileUploadPDP.ei1.Main.Model'
], function (
    file_upload_pdp_tpl,
    Backbone,
    Utils,
    FileUploadPDPModel
) {
    'use strict';

    // ---- Custom line field ----
    // Single Free-Form Text Item Option holding the uploaded file's URL.
    // Writing the URL directly here means the value lands straight on the
    // Sales Order line with no backend script needed - IF CPQ accepts a
    // JS-written option value at Add to Cart. Free-Form Text (not
    // Hyperlink) is used deliberately: it's the most permissive type and
    // least likely to trip CPQ's cart-time value validation.
    var FIELD_FILE_URL = 'custcol_upload_file_url';

    // Item Option storing the RAW uploaded page count (e.g. 6) for
    // reference on the order line. Pricing no longer uses this - pricing is
    // handled by the line quantity (see below) - it's just a record of how
    // many pages the uploaded file had. Free-form text, hidden.
    var FIELD_PAGE_COUNT = 'custcol_upload_page_count';

    // Item Option storing the real number of COPIES the customer wants
    // (e.g. 2). The native line quantity is driven to pages*copies so that
    // NetSuite prices the matrix line natively (rate * quantity) and every
    // total is correct on PDP/cart/checkout; this field preserves the true
    // copy count so the order still reads "2 copies". Hidden.
    var FIELD_COPIES = 'custcol_quantity';

    // Hard ceiling on pages*copies, mirroring the reference implementation,
    // so a huge upload x huge copy count can't create an absurd line qty.
    var MAX_TOTAL_PAGES = 100000;

    var ALLOWED_EXTENSIONS = {
        'pdf': 'pdf',
        'jpg': 'image',
        'jpeg': 'image',
        'png': 'image'
    };

    // NetSuite's File Cabinet hard-rejects files over 10MB at file.create()
    // time. We cap a little under that (9MB) so the base64 size estimate and
    // encoding overhead can't push a borderline file over NetSuite's limit
    // after it's already passed this check.
    var MAX_FILE_SIZE_MB = 9;

    function getExtension(filename) {
        return filename.split('.').pop().toLowerCase();
    }

    // @class FileUploadPDP.ei1.Main.View @extends Backbone.View
    return Backbone.View.extend({

        template: file_upload_pdp_tpl,

        initialize: function initialize(options) {
            console.log('[FileUploadPDP] initialize() called');
            this.layout = options.container.getComponent('PDP');
            this.uploadedFile = null;
            this.pageCount = 0;
            this.currentBlobUrl = null;
            // Scope class: our widget only mounts on the enabled Copy item,
            // so tagging <body> lets all our CSS target ONLY this item's PDP
            // (e.g. hiding the native quantity) without affecting any other
            // product page, since the extension stylesheet loads site-wide.
            $('body').addClass('ufm-copy-pdp');
            this._bindNativeQuantityEvents();
            this._bindAddToCartGuard();
            this._bindOptionChange();
            this.model = new FileUploadPDPModel();
        },

        // The layout's afterOptionSelection event doesn't fire reliably in
        // this SCA version, so we also listen directly to option <select>
        // changes on the page. Either path triggers the settle+recompute.
        _bindOptionChange: function _bindOptionChange() {
            var self = this;
            this._optionChangeHandler = function () {
                if (self.uploadedFile && self.recalculatePriceWhenSettled) {
                    self.recalculatePriceWhenSettled();
                }
            };
            // Delegated: catches current and re-rendered option selects.
            $(document).on('change.fupdpOptions',
                '.product-details-options-container select, ' +
                '.product-views-options select, ' +
                '[data-view="Product.Options"] select, ' +
                '.product-details-full-product-options-container select',
                this._optionChangeHandler);
        },

        // Gate SCA's "Add to Cart" until a file is uploaded. Two layers,
        // because SCA binds its own add-to-cart via Backbone delegation on a
        // parent element, so a document-level capture listener with
        // stopImmediatePropagation does NOT reliably beat it:
        //   1. Keep the Add to Cart button visually/functionally disabled
        //      while no file is present (hard guarantee, wiring-independent).
        //   2. Also intercept clicks directly ON the button in capture phase
        //      as a backup, in case SCA re-enables/re-renders the button.
        // The button is re-scanned on a short interval because SCA re-renders
        // the PDP (and thus the button) on option/quantity changes, which
        // would otherwise drop our disabled state / listener.
        _bindAddToCartGuard: function _bindAddToCartGuard() {
            var self = this;
            this._addToCartSelector = '.cart-add-to-cart-button-button, [data-type="add-to-cart"]';

            this._addToCartHandler = function (e) {
                if (self.uploadedFile) {
                    return;
                }
                e.preventDefault();
                e.stopImmediatePropagation();
                self._showUploadRequiredError();
            };

            this._syncAddToCartState = function () {
                if (!self.$('#drag-area').length) {
                    return;
                }
                var $btns = $(self._addToCartSelector);
                $btns.each(function () {
                    var btn = this;
                    // (Re)bind our capture listener idempotently.
                    btn.removeEventListener('click', self._addToCartHandler, true);
                    btn.addEventListener('click', self._addToCartHandler, true);
                    // Reflect upload state on the button itself.
                    if (self.uploadedFile) {
                        btn.removeAttribute('disabled');
                        btn.classList.remove('ufm-atc-disabled');
                    } else {
                        btn.setAttribute('disabled', 'disabled');
                        btn.classList.add('ufm-atc-disabled');
                    }
                });
            };

            // Initial pass + keep it in sync through SCA's re-renders.
            this._syncAddToCartState();
            this._addToCartInterval = setInterval(this._syncAddToCartState, 300);
        },

        _showUploadRequiredError: function _showUploadRequiredError() {
            this.$('.ufm-error')
                .text('Please upload your file before adding this item to the cart.')
                .show();
            var dropzone = this.$('#drag-area')[0];
            if (dropzone && dropzone.scrollIntoView) {
                dropzone.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        },

        // Called after a successful upload so the button unlocks immediately
        // rather than waiting for the next interval tick.
        _refreshAddToCartState: function _refreshAddToCartState() {
            if (this._syncAddToCartState) {
                this._syncAddToCartState();
            }
        },

        // The native SCA quantity selector is no longer the customer's
        // control - we drive the line quantity programmatically to
        // pages*copies (the quantity trick). So we hide the native selector
        // and keep it in sync with pages*copies instead of reacting to it.
        // (Hiding is also done in SCSS; this is a JS fallback in case the
        // selector re-renders before the stylesheet applies.)
        _bindNativeQuantityEvents: function _bindNativeQuantityEvents() {
            var self = this;
            this._hideNativeQty = function () {
                $('.product-details-quantity-options, ' +
                  '.product-views-option-quantity, .product-details-quantity, ' +
                  '.product-details-options-quantity, .product-line-quantity, ' +
                  '.product-views-option-color-quantity, .quantity-control, ' +
                  '.product-details-quantity-container').hide();
            };
            this._hideNativeQty();
            // SCA re-renders on option changes; keep it hidden.
            this._hideNativeQtyInterval = setInterval(this._hideNativeQty, 500);
        },

        remove: function remove() {
            $('body').removeClass('ufm-copy-pdp');
            $(document).off('.fupdpQuantity');
            $(document).off('.fupdpOptions');
            if (this._settleTimer) {
                clearInterval(this._settleTimer);
            }
            if (this._hideNativeQtyInterval) {
                clearInterval(this._hideNativeQtyInterval);
            }
            if (this._addToCartInterval) {
                clearInterval(this._addToCartInterval);
            }
            if (this._addToCartHandler && this._addToCartSelector) {
                var self = this;
                $(this._addToCartSelector).each(function () {
                    this.removeEventListener('click', self._addToCartHandler, true);
                    this.removeAttribute('disabled');
                    this.classList.remove('ufm-atc-disabled');
                });
            }
            Backbone.View.prototype.remove.apply(this, arguments);
        },

        events: {
            'change [id="uploadDocument"]': 'onFileSelected',
            'click [id="drag-area"]': 'clickDragArea',
            'change #ufm-copies-input': 'onCopiesChange',
            'keyup #ufm-copies-input': 'onCopiesChange',
            'click .ufm-copies-step': 'onCopiesStep'
        },

        getContext: function getContext() {
            return {};
        },

        clickDragArea: function clickDragArea() {
            this.$('#uploadDocument')[0].click();
        },

        onFileSelected: function onFileSelected(e) {
            var self = this;
            var file = e.target.files[0];
            var $error = this.$('.ufm-error');

            $error.text('').hide();

            if (!file) {
                return;
            }

            var validation = this.validateFile(file);
            if (!validation.valid) {
                $error.text(validation.message).show();
                this.$('#uploadDocument').val('');
                return;
            }

            this.selectedFile = file;
            var ext = getExtension(file.name);
            var fileType = ALLOWED_EXTENSIONS[ext];

            if (fileType === 'pdf') {
                this.countPdfPages(file, function (count) {
                    self.pageCount = count;
                    self.showLocalPreview(file, fileType);
                });
            } else {
                this.pageCount = 1;
                this.showLocalPreview(file, fileType);
            }

            this.uploadFileToNetSuite(file);
        },

        showLocalPreview: function showLocalPreview(file, fileType) {
            var self = this;

            window.fileUploaded = true;
            this.$('#drag-area h3').remove();
            this.$('#drag-area p').text(file.name);
            this.updatePageCountDisplay();

            if (fileType === 'pdf') {
                if (this.currentBlobUrl) {
                    URL.revokeObjectURL(this.currentBlobUrl);
                }
                this.currentBlobUrl = URL.createObjectURL(file);

                this.renderImageContainer(
                    '<iframe src="' + this.currentBlobUrl + '" width="100%" height="555"></iframe>' +
                    '<p class="ufm-pdf-filename">' + this.escapeHtml(file.name) + '</p>'
                );
            } else {
                var reader = new FileReader();
                reader.onload = function (evt) {
                    self.renderImageContainer(
                        '<img src="' + evt.target.result + '" alt="Uploaded file preview" />'
                    );
                };
                reader.readAsDataURL(file);
            }
        },

        renderImageContainer: function renderImageContainer(html) {
            var $gallery = $('[data-view="Product.ImageGallery"]');

            if (!$gallery.length) {
                console.log('[FileUploadPDP] Product.ImageGallery view not found on this page.');
                return;
            }

            $gallery.hide();

            var $existingPreview = $('.ufm-uploaded-preview');
            if ($existingPreview.length) {
                $existingPreview.remove();
            }

            $gallery.after('<div class="ufm-uploaded-preview">' + html + '</div>');
        },

        restoreGallery: function restoreGallery() {
            $('[data-view="Product.ImageGallery"]').show();
            $('.ufm-uploaded-preview').remove();
        },

        escapeHtml: function escapeHtml(str) {
            return String(str)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;');
        },

        validateFile: function validateFile(file) {
            var ext = getExtension(file.name);

            if (!ALLOWED_EXTENSIONS.hasOwnProperty(ext)) {
                return { valid: false, message: 'Only PDF, JPG, and PNG files are allowed.' };
            }
            if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
                return { valid: false, message: 'File must be smaller than ' + MAX_FILE_SIZE_MB + 'MB.' };
            }
            return { valid: true };
        },

        countPdfPages: function countPdfPages(file, callback) {
            var reader = new FileReader();
            reader.onloadend = function () {
                var matches = reader.result.match(/\/Type[\s]*\/Page[^s]/g);
                var count = matches ? matches.length : 1;
                callback(count);
            };
            reader.onerror = function () {
                callback(1);
            };
            reader.readAsBinaryString(file);
        },

        // Sends the file to the same Suitelet/File Cabinet flow already
        // in production: model.save({fileName, fileType, base64Data},
        // {type:'POST', success, error}) -> backend returns
        // { success, data: { fileId } }.
        uploadFileToNetSuite: function uploadFileToNetSuite(file) {
            var self = this;

            this.$('#upload-modal').show();

            var reader = new FileReader();
            reader.onload = function () {
                var base64Data = reader.result.split(',')[1];

                console.log('[FileUploadPDP] formData being sent, fileName:', file.name);
                console.log('[FileUploadPDP] model url:', self.model.url());

                self.model.save(
                    {
                        fileName: file.name,
                        fileType: file.type,
                        base64Data: base64Data
                    },
                    {
                        type: 'POST',
                        success: function (model, response) {
                            console.log('[FileUploadPDP] save SUCCESS callback, raw response:', response);
                            self.$('#upload-modal').hide();

                            if (!response || !response.success || !response.data || !response.data.fileId) {
                                console.warn('[FileUploadPDP] response did not have expected shape, local preview still stands.', response);
                                self.$('.ufm-error').text(
                                    (response && response.message) || 'Something went wrong uploading your file. Please try again.'
                                ).show();
                                return;
                            }

                            self.onUploadSuccess(response.data, file);
                        },
                        error: function (model, xhr) {
                            console.error('[FileUploadPDP] save ERROR callback', xhr);
                            self.$('#upload-modal').hide();
                            self.$('.ufm-error').text('Something went wrong uploading your file. Please try again.').show();
                            console.log('[FileUploadPDP] backend upload failed - local preview still stands.');
                        }
                    }
                );
            };
            reader.onerror = function () {
                self.$('#upload-modal').hide();
                console.log('[FileUploadPDP] failed to read file for base64 conversion.');
            };
            reader.readAsDataURL(file);
        },

        // fileData here is our backend's { fileId, fileUrl } payload, not
        // a full file record - so the local preview (blob URL / base64
        // image) set in showLocalPreview() stays on screen; we don't
        // swap it for the File Cabinet URL, we just use that URL for the
        // order line's image field.
        onUploadSuccess: function onUploadSuccess(fileData, originalFile) {
            this.uploadedFile = {
                id: fileData.fileId,
                name: originalFile.name,
                url: fileData.fileUrl
            };
            window.uploadedFileId = fileData.fileId;

            this.setLineFields(this.uploadedFile);

            // setOption() writes the value directly into the options model
            // but doesn't fire the native input "change" event the way a
            // customer typing into a visible option field would. On a
            // CPQ-configurable item, that native event is what triggers
            // CPQ's own price/configuration recalculation - without it,
            // Add to Cart validates against a stale configuration snapshot
            // that predates this value, and rejects the item. Forcing a
            // recalculation (and re-emitting the same event Main.js already
            // listens for on quantity changes) keeps that snapshot current.
            this.recalculatePrice();
            if (this.layout && typeof this.layout.trigger === 'function') {
                this.layout.trigger('afterOptionSelection');
            }

            // Drive the line quantity to pages*copies so the matrix line
            // prices correctly everywhere (PDP, cart, checkout, totals).
            this.applyQuantityForPages();
            // Compute the price now IF all options are already selected;
            // otherwise it stays hidden until they are (gated inside).
            this.recalculatePriceWhenSettled();

            // File is in - clear any "please upload" error and unlock the
            // Add to Cart button right away instead of waiting for the poll.
            this.$('.ufm-error').text('').hide();
            this._refreshAddToCartState();
        },

        setLineFields: function setLineFields(uploadedFile) {
            if (!this.layout || !this.layout.setOption) {
                console.warn('[FileUploadPDP] layout.setOption is not available - cannot write line field.');
                return;
            }
            console.log('[FileUploadPDP] setLineFields() called with:', uploadedFile);
            this.layout.setOption(FIELD_FILE_URL, uploadedFile.url);
            // Send the page count as a string (free-form text option). Guard
            // to at least 1 so a parse miss can never zero out the price.
            var pages = this.pageCount && this.pageCount > 0 ? this.pageCount : 1;
            this.layout.setOption(FIELD_PAGE_COUNT, String(pages));
            console.log('[FileUploadPDP] options set - url:', uploadedFile.url, '| pageCount:', pages);
        },

        updatePageCountDisplay: function updatePageCountDisplay() {
            this.$('#ufm-page-count-display').text(this.pageCount || '');
            this.updateTotalPagesDisplay();
            this.recalculatePrice();
        },

        // The number of COPIES the customer wants (from our own input, not
        // the native SCA quantity box). Defaults to 1.
        getCopies: function getCopies() {
            var val = parseInt(this.$('#ufm-copies-input').val(), 10);
            return val > 0 ? val : 1;
        },

        // The quantity trick: set the native line quantity to pages*copies
        // so NetSuite prices the matrix line (rate * quantity) correctly
        // everywhere, while the real copy count is preserved in its own
        // option field. Also mirrors pages*copies into the Total Pages
        // display. Called after upload and whenever copies changes.
        applyQuantityForPages: function applyQuantityForPages() {
            if (!this.layout || !this.layout.setQuantity) {
                return;
            }
            var pages = this.pageCount && this.pageCount > 0 ? this.pageCount : 1;
            var copies = this.getCopies();
            var lineQty = pages * copies;

            if (lineQty > MAX_TOTAL_PAGES) {
                this.$('.ufm-error')
                    .text('That exceeds the maximum of ' + MAX_TOTAL_PAGES + ' total pages. Please reduce copies.')
                    .show();
                return;
            }
            this.$('.ufm-error').hide();

            this.layout.setQuantity(lineQty);
            if (this.layout.setOption) {
                this.layout.setOption(FIELD_COPIES, String(copies));
            }

            this.$('#ufm-total-pages-display').text(lineQty);
            this.recalculatePrice();
        },

        onCopiesChange: function onCopiesChange() {
            // Only meaningful once a file is uploaded (pageCount known).
            this.applyQuantityForPages();
        },

        onCopiesStep: function onCopiesStep(e) {
            var dir = this.$(e.currentTarget).data('step'); // 'up' or 'down'
            var $input = this.$('#ufm-copies-input');
            var val = parseInt($input.val(), 10) || 1;
            val = dir === 'down' ? Math.max(1, val - 1) : val + 1;
            $input.val(val);
            this.applyQuantityForPages();
        },

        updateTotalPagesDisplay: function updateTotalPagesDisplay() {
            var copies = this.getCopies();
            var total = (this.pageCount || 0) * copies;
            this.$('#ufm-total-pages-display').text(total);
        },

        // Per-unit (per-page) matrix price, captured from the layout. We
        // read it when quantity is still the base so it reflects the unit
        // price, not an already-multiplied amount.
        // The per-page unit price of the currently selected matrix option.
        // There are TWO .product-views-price-lead elements and they can be
        // out of sync mid-transition, so reading the DOM is unreliable. The
        // authoritative source is SCA's price model via the layout, which
        // reflects the currently selected matrix child. We read that, and
        // only fall back to the (visible) DOM lead if the model has no price.
        // The per-page unit price = the VISIBLE matrix price lead. There are
        // two .product-views-price-lead elements; only one is visible and it
        // holds the price for the currently selected option. (Confirmed by
        // diagnostic: element 0 visible, element 1 hidden.)
        // True only when every option <select> on the PDP has a real value
        // chosen (not the empty "- Select -" placeholder). We use this to
        // gate the price: computing before the matrix is fully resolved
        // reads a transitional/default price (the source of the wrong
        // $1.52). SCA's option selects live in the options container.
        allOptionsSelected: function allOptionsSelected() {
            var selects = document.querySelectorAll(
                '.product-details-options-container select, ' +
                '.product-views-options select, ' +
                '[data-view="Product.Options"] select, ' +
                '.product-details-full-product-options-container select'
            );
            if (!selects.length) {
                // No option selects found - nothing to gate on; treat as
                // selected so single-SKU items still price.
                return true;
            }
            for (var i = 0; i < selects.length; i++) {
                var v = selects[i].value;
                if (!v || v === '' || v === 'null' || /^-.*-$/.test(v)) {
                    return false;
                }
            }
            return true;
        },

        getUnitPrice: function getUnitPrice() {
            var unit = 0;
            $('.product-views-price-lead').each(function () {
                var el = this;
                // offsetParent === null means hidden; skip it.
                if (el.offsetParent !== null) {
                    var parsed = parseFloat((el.textContent || '').replace(/[^0-9.]/g, ''));
                    if (!isNaN(parsed) && parsed > 0) {
                        unit = parsed;
                        return false;
                    }
                }
            });
            return unit;
        },

        // Called on option change: show a brief overlay, wait for SCA's
        // matrix price to settle (it updates asynchronously after the
        // option changes), then recompute our price from the settled value.
        // Settle = the visible unit price reads the same twice in a row, or
        // we hit the attempt cap.
        recalculatePriceWhenSettled: function recalculatePriceWhenSettled() {
            var self = this;
            if (!this.uploadedFile) {
                return; // nothing to price until a file is uploaded
            }
            // Only compute once every option is chosen - otherwise we'd read
            // a transitional matrix price (the wrong $1.52).
            if (!this.allOptionsSelected()) {
                this.$('#ufm-price-row').hide();
                return;
            }

            this._showPriceOverlay();

            var attempts = 0;
            var maxAttempts = 20;      // ~2s cap at 100ms
            var intervalMs = 100;
            var lastSeen = null;
            var stableCount = 0;

            if (this._settleTimer) {
                clearInterval(this._settleTimer);
            }
            this._settleTimer = setInterval(function () {
                attempts++;
                var unit = self.getUnitPrice();

                if (unit > 0 && unit === lastSeen) {
                    stableCount++;
                } else {
                    stableCount = 0;
                }
                lastSeen = unit;

                // Settled (seen same value twice) or timed out.
                if ((unit > 0 && stableCount >= 1) || attempts >= maxAttempts) {
                    clearInterval(self._settleTimer);
                    self._settleTimer = null;
                    self.applyQuantityForPages(); // sets qty + recalculatePrice()
                    self.recalculatePrice();
                    self._hidePriceOverlay();
                }
            }, intervalMs);
        },

        _showPriceOverlay: function _showPriceOverlay() {
            if (this.$('#ufm-price-overlay').length) {
                this.$('#ufm-price-overlay').show();
                return;
            }
            var html = '<div id="ufm-price-overlay" class="ufm-price-overlay">' +
                '<div class="ufm-price-overlay-box">Updating price&hellip;</div></div>';
            this.$el.append(html);
        },

        _hidePriceOverlay: function _hidePriceOverlay() {
            this.$('#ufm-price-overlay').hide();
        },

        // Show unitPrice * pages * copies. There are TWO
        // .product-views-price-lead elements on this PDP and SCA re-renders
        // them back to the per-unit price on every option change, so writing
        // to them alone never holds. The reliable display is our OWN
        // #ufm-price-display element inside this widget (SCA never touches
        // it); we also best-effort write every SCA lead so the big headline
        // price matches when it isn't mid-re-render.
        recalculatePrice: function recalculatePrice() {
            var pages = this.pageCount && this.pageCount > 0 ? this.pageCount : 0;
            if (!pages) {
                // No upload yet - leave native price alone, hide our row.
                this.$('#ufm-price-row').hide();
                return;
            }
            // Don't show a price until every option is selected (avoids the
            // transitional wrong read).
            if (!this.allOptionsSelected()) {
                this.$('#ufm-price-row').hide();
                return;
            }
            var copies = this.getCopies();
            var unit = this.getUnitPrice();
            if (!unit || unit <= 0) {
                return;
            }
            var total = unit * pages * copies;
            var text = '$' + total.toFixed(2);

            // Our own controlled element only - we deliberately leave SCA's
            // headline price ($0.25 per-page) untouched, and show the
            // computed total here on our "Price:" line instead.
            this.$('#ufm-price-display').text(text);
            this.$('#ufm-price-row').show();
        },

        resetFields: function resetFields() {
            this.uploadedFile = null;
            this.pageCount = 0;
            window.fileUploaded = false;

            this.$('#ufm-page-count-display').text('');
            this.$('#ufm-total-pages-display').text('0');
            this.$('#ufm-copies-input').val(1);

            if (this.layout) {
                if (this.layout.setQuantity) {
                    this.layout.setQuantity(1);
                }
                if (this.layout.setOption) {
                    this.layout.setOption(FIELD_FILE_URL, '');
                    this.layout.setOption(FIELD_PAGE_COUNT, '');
                    this.layout.setOption(FIELD_COPIES, '1');
                }
            }

            // File cleared - re-lock Add to Cart.
            this._refreshAddToCartState();
        }

    });
});
